import { MarketingShell } from "@/components/landing/MarketingShell";
import { FAQ2, ALL_FAQS } from "@/components/landing2/FAQ2";
import { SeoHead } from "@/components/useSeo";

const generateStructuredMarkup = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: ALL_FAQS.map(faq => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a
      }
    }))
  };
};

function Page() {
  const jsonLd = generateStructuredMarkup();

  return (
    <>
      <SeoHead path="faq">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd).replace(/</g, "\\u003c")
          }}
        />
      </SeoHead>

      <MarketingShell className="flex flex-col justify-center">
        <section className="container py-20">
          <FAQ2 />
        </section>
      </MarketingShell>
    </>
  );
}

export default Page;
